import { useCallback } from 'react';
import { useGetOwnProfileQuery, useUpdateTopicPreferencesMutation } from '../api/UserApi';
import { TopicPreferences } from 'model';
import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { LoginState } from '../state/loginSlice';
import { useLoggedIn } from './useLoggedIn';

export interface TopicPreferencesState {
	updateTopicPreferences: (topicPreferences: TopicPreferences) => Promise<void>;
	isError: boolean;
	isSuccess: boolean;
	isLoading: boolean;
	error?: unknown;
	topicPreferences?: TopicPreferences;
}

export function useTopicPreferences(): TopicPreferencesState {
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const loggedIn = useLoggedIn();
	const {
		isError: isProfileError,
		data: user,
		error: profileError,
		isLoading: isProfileLoading
	} = useGetOwnProfileQuery(state.user._id, { skip: !loggedIn.realUser });
	const [update, { isError, isSuccess, error, isLoading }] = useUpdateTopicPreferencesMutation();
	const updateTopicPreferences = useCallback(
		async (topicPreferences: TopicPreferences): Promise<void> => {
			if (user === undefined) {
				return;
			}
			await update({
				user: {
					...user,
					topicPreferences
				}
			});
		},
		[update, user]
	);
	return {
		updateTopicPreferences,
		topicPreferences: user?.topicPreferences,
		isError: isError || isProfileError,
		isSuccess,
		isLoading: isLoading || isProfileLoading,
		error: error || profileError
	};
}
